import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const FormTitleBox = styled.p(({ theme }) => ({
  fontWeight: theme.fontWeight.bold,
  marginBottom: "4.8rem",
  fontSize: "2rem",
}));

const FormTitle = ({ children }: { children: React.ReactNode }) => {
  const { t } = useTranslation();

  return <FormTitleBox>{t(children as string)}</FormTitleBox>;
};

export default FormTitle;
